import { Link, useLocation } from 'react-router-dom'
import { allRoutes } from '../../../routing/All_Routes'
import { constraintConfig } from '../../../../constraintConfig'
import { selectAuth } from '../../../../features/authSlice'
import { useAppSelector } from '../../../../hooks'

const QueryReportTabs = () => {
    const location = useLocation()
    const { roleID } = useAppSelector(selectAuth);

    return (
        <div className='card ss-analytics-tabs-card' style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
            <div className='ss-analytics-tabs-scroll-wrap ss-mobile-scroll-tabs px-3 px-sm-6 px-lg-8 border-bottom py-2'>
                <div className='btn-group ss-analytics-tabs ss-user-tab-group' role='group' aria-label='Analytics report tabs'>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/expense-summary`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/expense-summary`}
                    >
                        Expense Summary
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/expense-detail`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/expense-detail`}
                    >
                        Expense Detail
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/expense-by-category`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/expense-by-category`}
                    >
                        Expense by Category
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/expense-violations`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/expense-violations`}
                    >
                        Expense Violations
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/category-budget`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/category-budget`}
                    >
                        Category Budget
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/export-expense`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/export-expense`}
                    >
                        Export Reports
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/user-report`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/user-report`}
                    >
                        User Report
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/user-cc-feeds`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/user-cc-feeds`}
                    >
                        User CC Feeds Report
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/report-ss-and-bc-data-match`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/report-ss-and-bc-data-match`}
                    >
                        Reconciliation Bank to BC Items Report
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/org-report/report-bank-and-bc-data-match`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/org-report/report-bank-and-bc-data-match`}
                    >
                        SS To BC Sync Items Detail
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default QueryReportTabs